/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'singlepanel': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g fill-rule="nonzero" _fill="none"><circle pid="0" cx="12" cy="12" r="12" _fill="#8300BF"/><path pid="1" d="M19.5 6.5h-15v11h15v-11zm-1 1v9h-13v-9h13z" _fill="#FFF"/></g>'
  }
})
